import axios from "axios";

export default {
    getTemplate(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/questionary/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    save(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/nosql/questionary",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    saveTab(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/questionary/tab",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    updateTemplate(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/questionary/tab",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    cloneTemplate(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/questionary/tab/clone",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    deleteTemplate(id) {
        return axios({
            method: "delete",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/questionary/tab/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
